import * as React from 'react';
import { SVGProps } from 'react';

const IconToolsDiameterInnerSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m11.16 5.547 3.194-3.193-.707-.708-3.194 3.194a4 4 0 0 0-5.613 5.613l-3.194 3.194.708.707 3.193-3.194a4 4 0 0 0 5.613-5.613Zm-2.144.73a2 2 0 0 0-2.74 2.74l2.74-2.74ZM6.984 9.723l2.74-2.739a2 2 0 0 1-2.74 2.74Z"
      fill="var(--color-typo-primary)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.048 2.83a6 6 0 0 0-8.217 8.217l.735-.734a5 5 0 0 1 6.747-6.747l.735-.735Zm-5.36 9.604a5 5 0 0 0 6.747-6.747l.734-.735a6 6 0 0 1-8.217 8.217l.735-.735Z"
      fill="var(--color-typo-secondary)"
    />
  </svg>
);
export default IconToolsDiameterInnerSizeS;
